import {Inject, Injectable} from '@angular/core';
import {EndUserService} from '../../../end-user.service';
import {HttpClient} from '@angular/common/http';
import {RestSimpleResponseParser, RestYiiFilterService, RestYiiPagination, RestYiiSort} from 'gelios-ng-admin-components';
import {BehaviorSubject, Observable, Subscription, timer} from 'rxjs';
import {EndUserModel} from '../../../models/end-user.model';
import {concatMap, expand, tap} from 'rxjs/operators';
import {EndUserExtendedRegistrationStatus} from '../../../../utility/extended-registration-status-type';

@Injectable({
  providedIn: 'root'
})
export class EndUserExtendedRegistrationService {
  updateEndUserExtendedRegistrationEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  extendedRegistrationEndUsers: BehaviorSubject<Array<EndUserModel>> = new BehaviorSubject<Array<EndUserModel>>([]);
  refreshObservable: Observable<any>;
  refreshSubscription: Subscription;
  refreshInterval = 30000;

  constructor(
    public http: HttpClient,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string
  ) {

    const endUserParams = this.endUserService().filter.getHttpParams({
      status_extended_registration: {
        type: 'equals',
        filter: EndUserExtendedRegistrationStatus.SUSPENSE,
        filterType: 'text',
        filterTo: null
      }
    }).append('expand', 'registration_date_timestamp');
    this.refreshObservable = this.endUserService().getAll(endUserParams).pipe(
      tap(response => this.extendedRegistrationEndUsers.next(response.body))
    );
  }

  endUserService(): EndUserService {
    return new EndUserService(
      this.http,
      new RestYiiFilterService(),
      new RestYiiSort(),
      new RestYiiPagination(),
      new RestSimpleResponseParser(),
      this.environmentVersion,
      this.environmentApiBasepoint
    );
  }

  startRefresh() {
    if (this.refreshSubscription) {
      this.stopRefresh();
    }
    this.refreshSubscription = this.refreshObservable.pipe(
      expand(() =>
        timer(this.refreshInterval)
          .pipe(concatMap(() => this.refreshObservable))
      )
    ).subscribe();
  }

  stopRefresh() {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }
}
